import React from "react";
import { Link } from "react-router-dom";
import MarketingHeader from "@/components/layout/MarketingHeader";
import MarketingFooter from "@/components/layout/MarketingFooter";

/**
 * Generic legal-page layout used by Terms, Privacy and Accessibility.
 * Pass title, kicker (overline), updated date, and children (page content).
 */
export default function LegalPage({ kicker, title, updated, children, testId }) {
  return (
    <div className="min-h-screen" data-testid={testId || "legal-page"}>
      <MarketingHeader />
      <section
        className="pt-32 lg:pt-40 pb-12 lg:pb-16 section-light"
        style={{ borderBottom: "1px solid var(--lh-border)" }}
      >
        <div className="max-w-[900px] mx-auto px-6 md:px-10 lg:px-14">
          <Link
            to="/"
            className="overline mb-6 inline-block"
            style={{ color: "var(--lh-cognac)" }}
          >
            ← LocalizeHER
          </Link>
          <div className="overline mb-4" style={{ color: "var(--lh-cognac)" }}>
            {kicker}
          </div>
          <h1 className="font-display-bold text-5xl md:text-7xl tracking-tighter leading-[0.95]">
            {title}
          </h1>
          {updated && (
            <p
              className="mt-6 text-xs uppercase tracking-wider"
              style={{ color: "var(--lh-greige)" }}
            >
              Last updated · {updated}
            </p>
          )}
        </div>
      </section>
      <section className="py-16 lg:py-24 section-light" data-testid="legal-body">
        <div className="max-w-[760px] mx-auto px-6 md:px-10 lg:px-14">
          <article className="prose-lh prose-lh--legal">{children}</article>
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
